// Sanitizer TIPADO del request de pago para tracking. WHITELIST: parte de los
// tipos TS conocidos (paymentModel) y arma un objeto NUEVO solo con lo seguro.
// Nunca pasa el payload original — un campo nuevo del backend no se filtra por
// accidente (a diferencia de un blacklist). El request es el único que contiene
// tarjeta; el response lo maneja el sanitizer genérico (errorPayload).
//
// PCI/PII: cvv, PAN completo, nombre del titular, DUI, IP, token CROEM NUNCA
// salen. Solo card_last4 (últimos 4, solo OnePay) + expiry (no crítico sin PAN).
//
// Plan: propi-web-nextjs/apuntes/plan/payment-tracking.md §5
import { OnePayPayload, CroemPaymentPayload } from '../models/paymentModel'

type CardPayload = OnePayPayload | CroemPaymentPayload
export type AnyPaymentRequest = CardPayload | FormData

export interface SafePaymentRequest {
  payment_method: 'card' | 'transfer'
  card_provider?: 'croem' | 'onepay'
  card_last4?: string | null // solo OnePay; CROEM tokeniza → null
  card_exp_month?: string // no crítico — solo OnePay
  card_exp_year?: string // no crítico — solo OnePay
  has_token?: boolean // CROEM
  has_voucher?: boolean // transfer
  transfer_reference?: string // identifier de la transferencia (no crítico)
}

const isOnePay = (p: CardPayload): p is OnePayPayload => 'cardInfo' in p

const last4 = (pan?: string): string | null => (pan ? pan.replace(/\D/g, '').slice(-4) : null)

export const sanitizePaymentRequest = (payload: AnyPaymentRequest): SafePaymentRequest => {
  // Transferencia: FormData con identifier/document(dui)/name/voucher → solo lo no-PII
  if (payload instanceof FormData) {
    return {
      payment_method: 'transfer',
      has_voucher: payload.has('voucher'),
      transfer_reference: (payload.get('identifier') as string) || undefined,
    }
  }
  // OnePay: el único con PAN en claro → últimos 4 + expiry (no crítico)
  if (isOnePay(payload)) {
    const { cardNumber, expireMonth, expireYear } = payload.cardInfo ?? {}
    return {
      payment_method: 'card',
      card_provider: 'onepay',
      card_last4: last4(cardNumber),
      card_exp_month: expireMonth,
      card_exp_year: expireYear,
    }
  }
  // CROEM: tokenizado client-side, sin PAN
  return {
    payment_method: 'card',
    card_provider: 'croem',
    card_last4: null,
    has_token: Boolean(payload.token),
  }
}
